import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banner-message-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = ["innerHTML"]

import { VIconSvg } from "@/components";
import { ref, useSlots } from "vue";
import { TranslateResult } from "vue-i18n";
import { isExistSlot } from "@/plugins/helpers";

interface Props {
  text?: string | TranslateResult;
  closable?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VMessage',
  props: {
    text: { default: "" },
    closable: { type: Boolean, default: false }
  },
  emits: ["closeMessage"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const slots = useSlots();

const props = __props;

const showMessage = ref(true);

const clickClose = () => {
  if (props.closable) {
    showMessage.value = false;
  }

  emit("closeMessage");
};

return (_ctx: any,_cache: any) => {
  return (showMessage.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isExistSlot)('icon', _unref(slots)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "icon")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "message",
          innerHTML: _ctx.text
        }, null, 8, _hoisted_3),
        (_ctx.closable)
          ? (_openBlock(), _createBlock(_unref(VIconSvg), {
              key: 1,
              name: "Close",
              class: "close-icon",
              color: "white",
              "color-tag": "stroke",
              onClick: clickClose
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})